import { restApiRP } from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApiRP.get("/api/inventory-exceptions", { params });
};

const getAllDetail = params => {
  return restApiRP.get("/api/inventory-exceptions/detail", { params });
};

const getAllForCSV = params => {
  return restApiRP.get("/api/inventory-exceptions/detail/csv", { params });
}

const inventoryExceptionsService = {
  getAll,
  getAllDetail,
  getAllForCSV
};

export default inventoryExceptionsService;